import React, { useEffect, useState } from "react";
import DefaultGrid from "../../Components/Default/DefaultGrid";
import {useFilters} from "../Filters/UseFilter";

interface props {
  pedidos: any
}

const CustomerRequests: React.FC<props> = ({ pedidos }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [columns, setColumns] = useState<any[]>([])
  const { filters, handleFilterChange } = useFilters([]);

  useEffect(() => {
    setColumns(
      [
        { key: "nr_pedido", label: "Número de Pedido", filterType: "text" },
        { key: "nome_usuario_imp", label: "Usuario", filterType: "text" },
        { key: "valor_frete", label: "Valor do frete", filterType: "text" },
        { key: "total_bruto", label: "Total Bruto", filterType: "text" },
        { key: "total", label: "Total", filterType: "text" },
      ]
    );
  }, []);

  return (
    <div className="d-flex flex-column container-fluid">
      <DefaultGrid
        title="Lista de Pedidos"
        columns={columns}
        filters={filters}
        handleFilterChange={handleFilterChange}
        items={pedidos}
        itemsPerPage={10}
        loading={loading}
      />
    </div>
  );
};

export default CustomerRequests;
